import { createSlice } from '@reduxjs/toolkit';
import { RESET_STATE } from '../../store/resetActions';

/**
 * Global notifications slice for displaying system-wide alerts
 * Used for permission denied errors, session issues, etc.
 */

const initialState = {
  notification: null, // { message: string, severity: 'error' | 'warning' | 'info' | 'success', autoHide?: boolean }
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    /**
     * Generic notification action
     * Note: Currently unused but available for showing custom notifications
     */
    showNotification: (state, action) => {
      state.notification = {
        message: action.payload.message,
        severity: action.payload.severity || 'info',
        autoHide: action.payload.autoHide !== false, // default true
        timestamp: Date.now(), // Used as key for Snackbar re-render
      };
    },
    clearNotification: (state) => {
      state.notification = null;
    },
    /**
     * Convenience action for permission denied errors
     */
    showPermissionDenied: (state, action) => {
      const requiredPermission = action.payload?.requiredPermission;
      const customMessage = action.payload?.message;

      state.notification = {
        message: customMessage ||
          (requiredPermission
            ? `You don't have permission to perform this action. Required: ${requiredPermission}`
            : 'You don\'t have permission to perform this action.'),
        severity: 'warning',
        autoHide: true,
        timestamp: Date.now(),
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET_STATE, () => initialState);
  },
});

export const { showNotification, clearNotification, showPermissionDenied } = notificationsSlice.actions;

export default notificationsSlice.reducer;
